export default "__VITE_ASSET__DunhN5BJ__"